"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author gevorg.avetisyan on 2/10/2017.
 */
var DisaggregationData = /** @class */ (function () {
    function DisaggregationData(data, isDna, sytemName, parent) {
        this.id = data.getId();
        this.isDna = isDna;
        this.name = data.getMultilingualName(); //TODO G.A.
        this.parent = parent;
        this.sytemName = sytemName;
    }
    return DisaggregationData;
}());
exports.DisaggregationData = DisaggregationData;
var DisaggregationItem = /** @class */ (function () {
    function DisaggregationItem() {
    }
    DisaggregationItem.prototype.getId = function () {
        return this.id;
    };
    DisaggregationItem.prototype.getMultilingualName = function () {
        return this.name;
    };
    return DisaggregationItem;
}());
exports.DisaggregationItem = DisaggregationItem;
/**
 * example
 * <pre>
 *     {
  "location1": {
    "items": [
      {
        "id": 1,
        "name": "Hayastan"
      }
    ]
  },
  "location2" : {
    "parent": {
      "systemName" : "locarion1"
    },
    "items": [
      {
        "id": 3,
        "name": "Lori",
        "parentId" : 1
      }
    ]
  }
}
 * </pre>
 */
var DisaggregationDataFilter = /** @class */ (function () {
    function DisaggregationDataFilter() {
    }
    return DisaggregationDataFilter;
}());
exports.DisaggregationDataFilter = DisaggregationDataFilter;
//# sourceMappingURL=disaggregation-data.model.js.map